<template>
    <div class="my_treat_page">
        <div class="head">
            <div class="info" style="width: 55%;">
                <div class="text" style="font-size: 16px;">{{uname }}</div>
                <div  class="text">
                    <span>{{usex }}</span>
                    <span> {{uage}}</span>
                    <span>{{uphone}}</span>
                </div>

            </div>
            <div class="info" style="width: 50%;margin-left: 35px;">
                <div class="text" style="text-align: left;">诊所：{{ ClinicName }}</div>
                <div class="text">工号：{{ dispname }}</div>
            </div>
        </div>
        <div class="list">
            <div class="list_top">
                <div :class="{user:true,active:item.status}" v-for="item in family" @click="chooseUser(item)">
                    <div>
                        <div class="item">{{ item.name }}</div>
                        <div class="item">{{item.phone && (item.phone).replace(/(\d{3})\d{4}(\d{4})/, "$1****$2") || ''}}</div>
                    </div>
                </div>
            </div>

            <div style="display: flex;justify-content: center;gap: 15px;" >
                <!-- $router.push({path:'/otherPay',query:{userid,customerid,}}) -->
                <div class="list_btn" @click="openBedPopup()">
                  {{ uroomid ? '床位：'+uroomname : '安排床位' }}
                </div>
                <div class="list_btn" @click="chooseOther()">
                    他人抵扣
                </div>
            </div>

            <van-checkbox-group v-model="result" v-if="list.length > 0">
                <div class="list_item"  v-for="item in list" :key="item.projectcode" >
                    <div style="display: flex;justify-content: space-between;margin-bottom: 10px;">
                        <div class="tream">
                            <van-checkbox  checked-color="#CF8C57" :name="item">
                                <div class="text">{{ item.projectname }}</div>
                            </van-checkbox>
                        </div>
                        <div class="text" style="font-size: 14px;font-weight: 400;">剩余次数：<span style="color: #EE0A23;">{{ item.surplusnum}}</span></div>
                    </div>
                    <van-cell :value="doctor.dispname" v-for="(doctor, index) in item.doctors" :key="item._key + '_' + doctor.username + '_' + index" :border="false" @click="chooseDoctor(item, index)" is-link>
                        <template #title>
                            <span v-if="doctor.ismain == 1" class="main-tag">主</span>
                            <span>执行医生：</span>
                        </template>
                        <template #value>{{ doctor.dispname }}</template>
                    </van-cell>
                    <div class="action-buttons">
<!--                        <div style="display:flex;align-items: center;">-->
<!--                            <van-icon name="add-o" />-->
<!--                            <van-button plain type="primary" size="small" class="l-btn" @click.stop="addDoctor(item)">添加医生</van-button>-->
<!--                        </div>-->
                        <van-button type="primary" color="#CF8C57" class="r-btn" size="small" @click="openAcupointDialog(item)">配穴分工</van-button>
                    </div>
                </div>


            </van-checkbox-group>
            <div class="has_no_data" style="margin-top: 40px;" v-else>
                当前无可分诊的理疗项目
            </div>

        </div>

        <div style="position: fixed;left: 0;right: 0;bottom: 20px;margin: 0 35px;">
            <van-button color="#CF8C57" round @click="assignTreat" size="large">确认分诊</van-button>
        </div>


        <van-popup v-model="showPicker" round position="bottom">
            <van-picker
                title="请选择医生"
                show-toolbar
                :columns="doctorList"
                :default-index="doctorList.findIndex(item => item.username == selectDoctor)"
                @cancel="showPicker = false"
                @confirm="onConfirmDoctor"
            ><template #option="item"><span v-if="item.ishelp == 1">(助)</span>{{ item.dispname }}</template>
        </van-picker>
        </van-popup>
        <van-popup v-model="showPicker2" round position="bottom">
            <van-picker
            title="请选择诊室"
            show-toolbar

            :columns="roomList"
            @confirm="onConfirmRoom"
            @cancel="showPicker2 = false"
        ><template #option="item">{{ item.roomname }}</template></van-picker>
        </van-popup>
        <!-- <van-popup v-model="showPay" closeable round position="bottom" :style="{height:'90%'}">
            <OtherPay></OtherPay>
        </van-popup> -->
        <van-dialog v-model="shownum" title="获取验证码" show-cancel-button confirm-button-color="#CF8C57" :before-close="close">
            <div style="padding: 5px;margin-bottom: 20px;">
                <van-field v-model="tel" label-width="50" type="tel" label="手机号" :center="true">
                    <template #left-icon>
                        <img src="@/assets/phone.png" alt="" style="height: 20px;width: 20px;">
                    </template>
                </van-field>
                <van-field
                    v-model="sms"
                    center
                    label-width="50"
                    clearable
                    label="验证码"
                    placeholder="请输入短信验证码"
                    >
                    <template #button>
                        <van-button size="small" color="#CF8C57" type="primary"  @click="sendCode" :disabled="countdown > 0">
                            {{ countdown > 0 ? `${countdown}秒后重新获取` : '获取验证码' }}
                        </van-button>
                    </template>
                    <template #left-icon>
                        <img src="@/assets/code.png" alt="" style="height: 20px;width: 20px;">
                    </template>
                </van-field>
            </div>
        </van-dialog>

        <van-dialog
            v-model:show="showBedPopup"
            :show-confirm-button="false"
            :close-on-click-overlay="true"
            class="bed-dialog">
          <template #title>
            <div class="dialog-title">
              <span>安排床位</span>
              <span class="close-icon" @click="showBedPopup = false">✕</span>
            </div>
          </template>
          <div class="bed-popup">
            <div class="patient-info-section">
              <div class="patient-header">{{uname}}</div>
              <div class="patient-detail">{{usex}} {{uage}} {{uphone}}</div>
            </div>
            <div class="bed-section">
              <div class="section-title">床位</div>
              <div class="bed-list">
                <div
                    v-for="bed in bedList"
                    :key="bed.room_id"
                    class="bed-item"
                    :class="{
                       'bed-occupied': bed.use_count > 0  && (bed.user_id != useuserid || bed.customer_id != usecustomerid),
                       'bed-available': bed.use_count <= 0 || (bed.use_count > 0 && bed.user_id == useuserid && bed.customer_id == usecustomerid),
                       'bed-selected': selectedBed?.room_id == bed.room_id
                    }"
                    @click="selectBed(bed)">
                  <div v-if="bed.room_id != -1" style="text-align: center">
                    <div>{{ bed.room_name }}</div>
                    <div v-if="bed.room_id != -1"> ({{ getBedStatusText(bed) }})</div>
                  </div>
                  <div v-else class="freeRoom">
                    <img src="@/assets/freeRoom.png" alt="">
                    <span>{{ bed.room_name }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="confirm-section">
              <div class="confirm-btn" @click="confirmAssignBed">确认安排</div>
            </div>
          </div>
        </van-dialog>

        <acupoint-allocation
            :visible.sync="showAcupointDialog"
            :qryType="1"
            :uname="uname"
            :usex="usex"
            :uage="uage"
            :uphone="uphone"
            :userId="Number(currentUserId)"
            :customerId="Number(currentCustomerId)"
            :tCode="currenttCode"
            :currentAcupointData="currentAcupointData"
            @save="handleAcupointSave"
        />
    </div>
</template>
<script>
import {
  wxtreattriageopr,
  wxtriageprojectqry,
  wxtriagedoctorroomqry,
  curuserqrytreattriage,
  wxtreatuserphonecaptchano,
  wxqryfreeroom
} from '@/api/medical'
import { mapGetters } from 'vuex'
import { Toast,Dialog } from 'vant';
import OtherPay from '../otherPay/index.vue'
import AcupointAllocation from '../acupointAllocation/index.vue'
export default{
    computed: {
            ...mapGetters([
                'username','dispname','clinicid'
            ]),
        },
        components:{
            OtherPay,
            AcupointAllocation
        },
    data(){
        return{
            tel:'',//手机号
            list:[],
            userList:[],
            result:[],
            showPicker:false,
            selectDoctor:null,
            showPicker2:false,
            treatitem:{},
            ClinicName:'',
            doctorList:[],
            roomList:[],
            family:[ ],
            radio:'',
            other:{},
            userprojectlist:[],
            len:'',
            shownum:false,
            sms:'',
            phone:'',
            countdown: 0,
            userid:this.$route.query.userid || localStorage.getItem('userida'),
            customerid:this.$route.query.customerid || localStorage.getItem('customerida'),
            usecustomerid:this.$route.query.customerid || localStorage.getItem('customerida'),
            useuserid:this.$route.query.userid || localStorage.getItem('userida'),
            uname:this.$route.query.name || localStorage.getItem('namea'),
            appointmentid: this.$route.query.appointmentid,
            uage:this.$route.query.age|| localStorage.getItem('agea'),
            usex:this.$route.query.sex || localStorage.getItem('sexa'),
            uphone:this.$route.query.phone || localStorage.getItem('phonea'),
            uroomid:this.$route.query.roomid,
            uroomname:this.$route.query.roomname,
            showPay:false,
            intervalId:null,
            historynum:null,
            showAcupointDialog:false,
            currentAcupointData:[],
            currentItemRef: null,
            currentUserId: null,
            currentCustomerId: null,
            currenttCode: null,

            showBedPopup:false,
            bedList:[],
            selectedBed:null,
            defaultDate: new Date(),
            date:'',
        }
    },
    mounted () {
        this.$store.dispatch('hideOrShowNav', false)

        this.getCurDate()

    },
    beforeRouteEnter(to, from, next) {

        if(from.path == '/otherPay'){
            next(vm =>{
                vm.uname = localStorage.getItem('namea')
                vm.uage = localStorage.getItem('agea')
                vm.usex = localStorage.getItem('sexa')
                vm.uphone = localStorage.getItem('phonea')
                vm.userid = localStorage.getItem('userida')
                vm.customerid = localStorage.getItem('customerida')
                // vm.userprojectlist = JSON.parse(localStorage.getItem('userprojectlist'))
                vm.historynum = localStorage.getItem('historynum')
                vm.result = []

                if(localStorage.getItem('familya') != 'undefined'){
                    vm.family = JSON.parse(localStorage.getItem('familya'))
                    vm.len = vm.family.length

                }else{

                    vm.len = 0
                    vm.family = []
                }

                // to.meta.keepAlive = true
                vm.ClinicName = sessionStorage.ClinicName
                // vm.getuser()

                if(localStorage.getItem('otherdata')){

                    vm.onConfirmOther(JSON.parse(localStorage.getItem('otherdata')|| ''))
                }


            })
        }else{
            next(vm =>{

                // to.meta.keepAlive = false
                vm.$store.dispatch('hideOrShowNav', false)
                vm.uname = localStorage.getItem('namea')
                vm.uage = localStorage.getItem('agea')
                vm.usex = localStorage.getItem('sexa')
                vm.uphone = localStorage.getItem('phonea')
                vm.userid = localStorage.getItem('userida')
                vm.customerid = localStorage.getItem('customerida')
                // vm.userprojectlist = JSON.parse(localStorage.getItem('userprojectlist'))
                vm.historynum = localStorage.getItem('historynum')
                vm.result = []
                vm.getuser()

            })
        }
    },
    beforeRouteLeave(to, from, next) {

        if(to.path == '/triage'){
            to.meta.keepAlive = true

            localStorage.removeItem('userida')
            localStorage.removeItem('customerida')
            localStorage.removeItem('namea')
            localStorage.removeItem('agea')
            localStorage.removeItem('sexa')
            localStorage.removeItem('phonea')
            localStorage.removeItem('familya')
            localStorage.removeItem('otherdata')
            // localStorage.removeItem('userprojectlist')
            localStorage.removeItem('historynum')
        }else if(to.path == '/otherPay'){
            to.meta.keepAlive = true
            localStorage.setItem('familya',JSON.stringify(this.family))
        }
        else if(to.path == '/'){
            from.meta.keepAlive = false
        }
        next()
    },
    created(){
        localStorage.setItem('userida', this.$route.query.userid);
        localStorage.setItem('customerida', this.$route.query.customerid);
        localStorage.setItem('namea', this.$route.query.name);
        localStorage.setItem('agea', this.$route.query.age);
        localStorage.setItem('sexa', this.$route.query.sex);
        localStorage.setItem('phonea', this.$route.query.phone);




        this.gettriageprojectqry(this.userid,this.customerid)
        this.getdoctorroomList()

        this.ClinicName = sessionStorage.ClinicName
    },
    methods:{
        close(action, done){

            if (action == 'confirm' && !this.sms.trim()) {
                Toast.fail('请输入验证码！')
                done(false)
            } else if(action == 'cancel'){
                this.countdown = 0;
                clearInterval(this.intervalId);
                this.intervalId = null

                done(true)

            }
            else {
                this.getTreat('3',this.sms.trim()).then(res=>{
                    if(res.response_head.retinfo.retcode == '0'){
                        done(true)
                    }else{
                        done(false)
                    }
                }).catch(err=>{

                    Toast.fail(err.response_head.retinfo.retmsg)
                    done(true)
                })

            }
        },
        sendCode() {
            // 模拟发送验证码的操作

            let data = {
                username:this.username,
                userid:this.other.userid,
                customerid:this.other.customerid
            }

            wxtreatuserphonecaptchano(data).then(response =>{

                this.countdown = 60;

                // 开始倒计时
                this.intervalId = setInterval(() => {
                    if (this.countdown > 0) {
                    this.countdown -= 1;
                    } else {
                    clearInterval(this.intervalId);
                    }
                }, 1000);


            }).catch(()=>{
                Toast.fail('获取验证码失败！')
            })

            // 设置倒计时为60秒

        },
        chooseOther(){
            this.$store.dispatch('changeIsRefresh', '1')
            this.$router.push({path:'/otherPay',query:{userid:this.$route.query.userid,customerid:this.$route.query.customerid,}})
        },
        chooseUser(item){
            this.list = []
            this.result = []
            let userid = this.$route.query.userid
            let customerid = this.$route.query.customerid
            this.tel =item.phone && (item.phone).replace(/(\d{3})\d{4}(\d{4})/, "$1****$2")
            // 用id判断
            this.family.map((val,index) => {
                if(item.userid == val.userid && item.customerid == val.customerid){
                    val.status = !val.status
                }else{
                    val.status = false
                }
                if(val.status ){
                    this.other = item

                    this.useuserid = val.userid
                    this.usecustomerid = val.customerid
                    userid = val.userid
                    customerid = val.customerid
                }
            })
            this.gettriageprojectqry(userid,customerid)
        },
        // 查看可分诊用户
        getuser(){
            let data = {
                username: this.username,
                userid:this.userid,
                customerid:this.customerid,
            }
            curuserqrytreattriage(data).then(response =>{

                this.family = response.response_body.list?.map(item =>{
                    item.status = false
                    return item
                })

                localStorage.setItem('familya',JSON.stringify(this.family))

                if(this.family == undefined){

                    this.len = '0'
                    this.family = []
                }else{

                    this.len = this.family.length
                }


                console.log(response.response_body.otherlist)
                if (response.response_body.otherlist && response.response_body.otherlist.length >0){
                  console.log(response.response_body.otherlist)
                  const otherItem = response.response_body.otherlist.find(
                      familyItem =>
                          familyItem.projectlist &&
                          familyItem.projectlist.some(
                              project => Number(project.curexecnum) > 0
                          )
                  )
                  if (otherItem){
                    if(localStorage.getItem('familya') != 'undefined'){
                      let arr = JSON.parse(localStorage.getItem('familya'))
                      if(arr.filter(val => val.userid == otherItem.userid && val.customerid == otherItem.customerid).length > 0){
                        Toast(`当前【${otherItem.name}】的账号已存在`)
                        return
                      }
                    }

                    console.log("otherdata",JSON.stringify(otherItem))
                    localStorage.setItem('otherdata',JSON.stringify(otherItem))
                    this.onConfirmOther(JSON.parse(localStorage.getItem('otherdata')|| ''))
                  }
                }else {
                  const defaultItem = this.family.find(
                      familyItem =>
                          familyItem.projectlist &&
                          familyItem.projectlist.some(
                              project => Number(project.curexecnum) > 0
                          )
                  )

                  console.log("--==",defaultItem)
                  if (defaultItem) {
                    this.chooseUser(defaultItem)
                  }
                }

            })
        },
        // 查询医生
        getdoctorroomList(){
            let data = {
                username: this.username,
                clinicid:sessionStorage.ClinicId,
                qrytype : '2'
            }
            wxtriagedoctorroomqry(data).then(response =>{

                this.doctorList = response.response_body.doctorlist
                this.roomList = response.response_body.roomlist
            })
        },
        onConfirmOther(val){
            // this.result = []
            // this.showPicker3 = false

            if(this.len){
                this.family?.map((val,index) => {
                    val.status = false

                })
            }

            this.list = val.projectlist
            this.other = val
            this.useuserid = val.userid
            this.usecustomerid = val.customerid
            this.tel =val.phone && (val.phone).replace(/(\d{3})\d{4}(\d{4})/, "$1****$2")


            val.status = true

            if(this.family.filter(item => val.userid == item.userid && val.customerid == item.customerid).length == 0){

                this.family.push(val)
            }
            localStorage.setItem('familya',JSON.stringify(this.family))
            // this.family.push(val)
            this.gettriageprojectqry(val.userid,val.customerid)

        },

        // 可分诊项目查询
        gettriageprojectqry(userid,customerid){
            let useuserid = ''
            let usecustomerid = ''
            if(this.userid == userid && this.customerid == customerid){
                 useuserid = ''
                 usecustomerid = ''
            }else{
                useuserid = this.$route.query.userid
                usecustomerid = this.$route.query.customerid
            }

            let data = {
                    username: this.username,
                    projectcode:'',
                    keyword:'',
                    userid,
                    customerid,
                    qrytype:'0',
                    qrypage:1,
                    useuserid,
                    usecustomerid,
                    clinicid:this.clinicid
                }
            wxtriageprojectqry(data).then(response =>{

                if(response.response_body.pages == 0){
                    this.userList = []
                    this.list = []
                }else{

                    if(userid == this.$route.query.userid && customerid == this.$route.query.customerid){

                        // this.userprojectlist = response.response_body.list[0].projectlist
                        this.historynum = response.response_body.list[0].historynum
                        // localStorage.setItem('userprojectlist',JSON.stringify(this.userprojectlist))
                        localStorage.setItem('historynum',this.historynum)
                    }
                    this.userList = response.response_body.list || []
                    this.list = response.response_body.list[0].projectlist.filter(item => item.surplusnum > 0) || []
                    this.result = this.list.filter(item => Number(item.curexecnum) > 0) // 默认选中
                    this.userprojectlist = response.response_body.list[0].projectlist
                    this.list.forEach((item, i) => {
                        if (!Array.isArray(item.doctors)) {
                            this.$set(item, 'doctors', [])
                        }

                        item._key = i
                        item.doctors = [
                            {
                                dispname: item.doctorname || this.dispname,
                                username: item.doctor || this.username,
                                ismain: 1
                            }
                        ],
                        item.room = '请选择诊室',
                        item.roomid = ''
                    })
                    this.uroomid = response.response_body.roomid
                    this.uroomname = !response.response_body.roomname && this.uroomid == -1 ? '无需床位' : response.response_body.roomname
                }

            })
        },
        assignTreat(){

            if(!this.uroomid){
              Toast('请先安排床位')
              return
            }

            if(this.result.length == 0){
                Toast('请选择分诊项目！')
                return
            }

            console.log("---",this.userprojectlist)

            // 消费患者
            let repeatlist = this.userprojectlist.filter(
                item => Number(item.curexecnum) > 0 && Number(item.execstatus) > 1
            )

            console.log("repeatlist",repeatlist)

            // 选中项目
            let result = []

            this.result.forEach(item => {
              const repeatItem = repeatlist.find(
                  r => r.projectcode === item.projectcode
              )

              if (repeatItem && Number(repeatItem.execstatus) > 1) {
                result.push(item)
              }
            })

            console.log("result",result)


            let msg = '';
            if(repeatlist.length > 0){
                if(result.length == 0){
                    msg =  `该患者当天有执行其他项目：${(repeatlist.map(item =>  item.projectname)).join('、')}，您确认是否再次分诊？`
                }else if(result.length){
                    msg = `该患者当天有执行项目：${(result.map(item =>  item.projectname)).join('、')}，您确认是否再次分诊？`
                }
            }else{
               if(+this.historynum > 0){
                msg = `该患者有历史未完成的项目，您确认是否再次分诊?`
               }else{
                msg = `您确认是否提交此分诊数据？`
               }
            }

            Dialog.confirm({
                title: '提示',
                message: msg,
                confirmButtonColor:'#CF8C57',
            })
            .then(() => {
                // on confirm
                this.treatJudge()
            })
            .catch(() => {
                // on cancel
            });



        },
        treatJudge(){
            let selectoption = '0';
            if(this.userid == this.useuserid) {
                if(this.customerid == this.usecustomerid) {
                    this.getTreat(selectoption)
                } else {
                    if(this.usecustomerid == 0) {
                        selectoption = '1'
                        this.getTreat(selectoption)
                    } else {
                        selectoption = '2'
                        this.getTreat(selectoption)
                    }
                }
            } else {
                this.sms = ''
                this.shownum = true
            }
        },
        getTreat(selectoption,captchano){

            var res = new Promise((resolve,reject)=>{



                let project = []
                this.result.forEach(item => {
                  project.push({
                    projectname: item.projectname,
                    projectcode: item.projectcode,
                    doctors: item.doctors,
                    allpoints: item.allpoints,
                    num: '1',
                  })
                })

                let data = {
                    username:this.username,
                    projectlist:project,
                    selectoption,
                    userid:this.userid,
                    customerid:this.customerid,
                    useuserid:this.useuserid,
                    usecustomerid:this.usecustomerid,
                    captchano,
                    execclinicid:sessionStorage.ClinicId,
                    appointmentid:this.appointmentid,
                    roomid:this.uroomid
                }

                console.log("req",data)

                wxtreattriageopr(data).then(response =>{
                    resolve(response)
                    this.$store.dispatch('changeIsRefresh', '1')
                    Toast({message:'分诊成功！',onClose:()=>{
                        // 跳转页面
                        // location.reload()
                        this.$router.push('/treatPage')
                    }

                    })

                })
                .catch((err) => {
                    // on cancel
                    resolve(err)
                    Toast.fail(err.response_head.retinfo.retmsg)
                });
            })
        return res
        },
       chooseDoctor(item, index){
           if (!this.doctorList || this.doctorList.length === 0) {
             Toast('暂无空闲医生')
             return
           }
            this.selectDoctor = item.doctor || this.username
            this.showPicker = true
            this.treatitem = {
                item,   // 直接用引用（关键）
                index
            }
        },
        chooseRoom(item){

            this.showPicker2 = true
            this.treatitem = item
        },
        addDoctor(item){
            const newDoctor = {
                dispname: '请选择医生',
                username: '',
                ismain: 0
            }
            this.$set(item, 'doctors', [...item.doctors, newDoctor])
        },
        onConfirmDoctor(val){

            const item = this.treatitem.item

            if (!item) return

            if (!Array.isArray(item.doctors)) {
                this.$set(item, 'doctors', [])
            }

            const newDoctors = item.doctors.map((d, i) => {
                if (i === this.treatitem.index) {
                    return {
                        ...d,
                        dispname: val.dispname,
                        username: val.username
                    }
                }
                return d
            })

            // 关键：直接替换引用
            this.$set(item, 'doctors', newDoctors)
            console.log("this.list",this.list)

            this.selectDoctor = null
            this.showPicker = false
        },
        onConfirmRoom(val){
            this.treatitem.room = val.roomname
            this.treatitem.roomid = val.roomid
            this.showPicker2 = false
        },
        openAcupointDialog(item) {
            this.currentItemRef = item
            this.currentAcupointData = item.doctors
            this.currentUserId = item.userid
            this.currentCustomerId = item.customerid
            this.currenttCode = item.projectcode
            this.showAcupointDialog = true
        },
        handleAcupointSave(newList,allPoints) {
          if (!this.currentItemRef) return

          // 关键：直接覆盖 doctors
          this.$set(this.currentItemRef, 'doctors', newList)
          this.$set(this.currentItemRef, 'allpoints', allPoints)
        },
        openBedPopup() {
          this.selectedBed = null
          this.bedList = []
          this.showBedPopup = true
          wxqryfreeroom({ clinicid: this.clinicid }).then(response => {
            if (response.response_body && response.response_body.list) {
              this.bedList = response.response_body.list
              // 增加“无需床位”选项
              this.bedList.push({
                room_id: -1,
                room_name: '无需床位',
                use_count: 0
              })

              let defaultBed = null
              if (this.uroomid) {
                defaultBed = this.bedList.find(
                    bed => bed.room_id == this.uroomid
                )
              }

              // 如果没有当前床位，则默认选中第一个空闲床位
              if (!defaultBed) {
                defaultBed = this.bedList.find(
                    bed => bed.use_count <= 0
                )
              }

              // 设置默认选中
              if (defaultBed) {
                this.selectedBed = defaultBed
              }
            }
          })
        },
        selectBed(bed) {
          // 无需床位允许选中
          if (bed.room_id != -1 && bed.use_count > 0) {
            return
          }

          if (bed.use_count > 0) {
            return
          }

          // 无需床位允许选中
          if (bed.room_id != -1 && bed.use_count > 0 && (bed.user_id != this.useuserid || bed.customer_id != this.usecustomerid)) {
            return
          }
          this.selectedBed = bed
        },
        getBedStatusText(bed) {
          // 无需床位
          if (bed.room_id == -1) {
            return ''
          }
          if (bed.use_count > 0) {
            if (this.useuserid ==  bed.user_id &&
                this.usecustomerid == bed.customer_id) {
              return '本人';
            }
            return '有人';
          }
          return '空闲';
        },
        confirmAssignBed() {
          if (!this.selectedBed) {
            Toast('请先选择床位')
            return
          }
          this.uroomid = this.selectedBed.room_id
          this.uroomname = this.selectedBed.room_name
          this.showBedPopup = false
        },
        getCurDate() {
          const nowDate = new Date();
          this.formatDate(nowDate)
        },
        formatDate(d) {
          const curDate = {
            year: d.getFullYear(),
            month: d.getMonth() + 1,
            date: d.getDate(),
          }
          const newmonth = curDate.month>=10?curDate.month:'0'+curDate.month
          const day = curDate.date>=10?curDate.date:'0'+curDate.date
          this.date = curDate.year + '-' + newmonth + '-' + day
          this.defaultDate = new Date(this.date);
        },
    }
}
</script>
<style lang="scss" scoped>
.my_treat_page{
    margin-bottom: 0;
    min-height: 100vh;
    background-color: #F6F6F4;
    .head{
        background-color: #CF8C57;
        border-radius: 10px;
        color: #fff;
        font-size: 12px;
        padding: 15px;
        display: flex;
        align-items: center;
        font-size: 12px;
        .text{
            margin-bottom: 10px;
            span{
                margin-right: 8px;
            }
        }
    }
    .list{
        background-color: #fff;
        border-radius: 10px;
        margin-top: -15px;
        padding: 15px 12px;
        margin-bottom: 80px;
        .list_top{

            display: flex;

                flex-wrap: wrap;
            .user{
                width: 95px;
                height: 45px;
                padding: 5px;
                text-align: center;
                background-color: #F5F5F5;
                border-radius: 8px;
                margin-right: 8px;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-wrap: wrap;
                margin-bottom: 8px;

                .item{
                    width: 80px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

            }
            .active{
                background: rgba(207,140,87,0.2);
                border-radius: 8px;
                border: 1px solid #CF8C57;
            }
        }
        .list_btn{
            width: 140px;
            height: 35px;
            line-height: 35px;
            border-radius: 17.5px;
            background-color: #CF8C57;
            font-size: 16px;
            color: #fff;
            text-align: center;
            margin-bottom: 10px;
        }
        .list_item{
            background-color: #F5F5F5;
            border-radius: 10px;
            padding: 10px;
            margin-bottom: 10px;

            .tream{
                display: flex;
                justify-content: space-between;
                align-items: center;
                .text{
                    font-weight: 600;
                    font-size: 16px;
                    color: #323333;
                    line-height: 22px;
                    text-align: left;
                }
            }
            .action-buttons{
                display: flex;
                justify-content: flex-end;
                gap: 10px;
                margin-top: 10px;
                .r-btn{
                    border-radius : 5px
                }
                .l-btn{
                    color:#323333;
                    background:none;
                    border:none;
                    padding:5px;
                }
            }
            .main-tag{
                background-color: #CF8C57;
                color: #fff;
                font-size: 11px;
                padding: 5px;
                border-radius: 50%;
                margin-right: 6px;
            }
        }
    }
    .van-cell{
        padding:0 5px 5px;
        background-color: #F5F5F5;

        ::v-deep .van-icon {
            display: flex;
            align-items: center;
        }
    }


}
::v-deep .van-checkbox__label{
    width: 100% !important;
}
.my_treat_page .van-cell {
    ::v-deep .van-field{

        background-color: #fff;
    }
}
.van-dialog{

    ::v-deep .van-dialog__header{
        padding: 10px 0  25px !important;
    }
    ::v-deep .van-field{
        background-color: #fff;
        margin-bottom: 5px;
    }
}

.bed-dialog :deep(.van-dialog__content) {
  max-height: 70vh;
  overflow-y: auto;
}
.bed-dialog :deep(.van-dialog__header) {
  padding: 20px 20px 10px !important;
}
.dialog-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.dialog-title span:first-child {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.close-icon {
  font-size: 20px;
  color: #999;
  cursor: pointer;
  line-height: 1;
}

.bed-popup {
  padding: 10px 0 0;
}
.patient-info-section {
  background: #CF8C57;
  border-radius: 12px;
  padding: 20px;
  margin: 0 20px 24px;
}
.patient-header {
  font-size: 22px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 10px;
}
.patient-detail {
  font-size: 16px;
  color: #fff;
}
.bed-section {
  padding: 0 20px;
}
.section-title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
}
.bed-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}
.bed-item {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  padding: 8px;
  flex-direction: column;
}
.bed-occupied {
  background: #ddd;
  color: #999;
  cursor: not-allowed;
}
.bed-available {
  background: #fff;
  border: 1px solid #CF8C57;
  color: #CF8C57;
}
.bed-selected {
  background: #CF8C57 !important;
  color: #fff !important;
  border: 1px solid #CF8C57;
}
.confirm-section {
  padding: 20px;
}
.confirm-btn {
  width: 100%;
  height: 50px;
  background: #CF8C57;
  color: #fff;
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 600;
}

.freeRoom{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.freeRoom img{
  width: 30px;
}
</style>
